import { useTranslation } from 'react-i18next';
import { T } from '../../components/text/TextEdit';
import { formatCreditsOnly } from '../../lib/credits';

// Shared credit display — credits ONLY, unit word from the locale. No USD (Ali, 2026-08-06):
// users buy in Rial and spend credits; a dollar hint here mixes the two money worlds.
// `peg` is still accepted so existing call sites need no edit; it is deliberately unused.
export function CreditAmount({ credits, peg, testId = 'credit-amount' }) {
  const { t } = useTranslation();
  return <span data-testid={testId} className="font-data"><T k="wallet.credits" values={{ balance: formatCreditsOnly(credits) }} /></span>;
}

// N-47: a second ModelCostBar lived here (test ids `round-cost*`, `model-picker`) alongside the
// live one in pipeline/ui.js (`model-cost-bar*`). Nothing rendered this copy — its only importers
// were its own tests — but two same-named components meant every fix landed on one and missed the
// other: the no-USD pass (#83) caught this copy and missed the live one, the always-visible pass
// (N-50 era) did the reverse. Deleted 2026-08-12; the ONE bar is pipeline/ui.js's, and the picker
// behavior this copy's tests covered moved to ModelCostBar.test.js.
